import React, { Component } from "react";
import ReactDOM from "react-dom";
import "../src/style.css";
import Routing from "../src/Routing/Routing";

ReactDOM.render(<Routing />, document.getElementById("root"));
